import { CSSProperties } from 'react';
import { IconName } from './types';

const SvgSpriteIcon = ({
  ...props
}: {
  style?: CSSProperties;
  className?: string;
}) => (
  <svg {...props}>
    <use xlinkHref={`#${IconName.TRANSPARENT}`} />
    <use xlinkHref={`#${IconName.SQUARE}`} />
  </svg>
);

export { SvgSpriteIcon };
